import type { UseFormReturn } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const passwordCreationFormSchema = z
  .object({
    confirmPassword: z.string().min(1, "Please confirm your password."),
    password: z
      .string()
      .min(1, "Please fill in this field.")
      .min(8, "Password must be at least 8 characters.")
      .regex(/[A-Z]/, "Password must contain at least one uppercase letter.")
      .regex(/[a-z]/, "Password must contain at least one lowercase letter.")
      .regex(/\d/, "Password must contain at least one number.")
      .regex(
        /[!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~\-]/,
        "Password must contain at least one symbol.",
      ),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match.",
    path: ["confirmPassword"],
  });

export type PasswordCreationFormData = z.infer<
  typeof passwordCreationFormSchema
>;

export function usePasswordCreationForm(
  initialData: PasswordCreationFormData,
): UseFormReturn<PasswordCreationFormData> {
  return useForm<PasswordCreationFormData>({
    defaultValues: {
      confirmPassword: initialData.confirmPassword || "",
      password: initialData.password || "",
    },
    resolver: zodResolver(passwordCreationFormSchema),
  });
}
